import React from 'react';

interface QRCodeDisplayProps {
  qrCodeDataUrl: string;
  size?: number;
  className?: string;
}

const QRCodeDisplay: React.FC<QRCodeDisplayProps> = ({ 
  qrCodeDataUrl, 
  size = 200, 
  className 
}) => {
  return (
    <img
      src={qrCodeDataUrl}
      alt="QR Code for MFA Setup"
      className={className}
      style={{ 
        display: 'block', 
        margin: '0 auto',
        width: size,
        height: size,
        border: '1px solid #ddd',
        borderRadius: '8px'
      }}
    />
  );
};

export default QRCodeDisplay;
